import { BREAKPOINTS } from "../config/breakpoints";
import React, { useState } from "react";
import styled from "styled-components";
import menu from "../Assets/menu.png";
import { NavLink, useLocation } from "react-router-dom";
import LandingConnector from "../Landing/Connector/LandingConnector";
import xook from "../Assets/Xook.png";
import Button from "../Generic/Button";
import SuccessButton from "../Generic/SuccessButton";
import { LogoutUser } from "../Login/Service/LoginService";
import { CSSTransition } from "react-transition-group";
import close from "../Assets/Close.png";
import blankProfile from "../Assets/blankProfile.png";
import { getAuth } from "firebase/auth";
import { beautifyKey } from "../util/util";
import useWindowSize from "../util/hooks/useWindowSize";
import { zIndex } from "../config/zIndex";

const Head = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 4.5rem;
	padding: 0 1rem;
	gap: 0.5rem;
	background: #fff;
	z-index: ${zIndex.appHeader};
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 0 0.75rem;
		gap: 0.25rem;
	}
`;

const Item = styled.div`
	display: flex;
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	flex-direction: ${(props) => props.flexDirection};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	font-size: ${(props) => props.fontSize};
	height: ${(props) => props.height};
	min-width: 0;
	overflow: hidden;
`;

const SubItem = styled.div`
	display: block;
	margin: ${(props) => props.margin};
	font-family: ${(props) => props.fontFamily};
	font-size: ${(props) => props.fontSize};
	font-weight: ${(props) => props.fontWeight};
	min-width: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		font-size: ${(props) => props.mobileFontSize || props.fontSize};
	}
`;

const Div = styled.div`
	height: ${(props) => props.height};
	position: ${(props) => props.postition};
	background: ${(props) => props.background};
	color: ${(props) => props.color};
	display: ${(props) => props.display ?? "flex"};
	flex-direction: ${(props) => props.flexDirection};
	flex-wrap: ${(props) => props.flexWrap};
	justify-content: ${(props) => props.jContent};
	align-items: ${(props) => props.alignItem};
	padding: ${(props) => props.padding};
	margin: ${(props) => props.margin};
	text-align: ${(props) => props.txtAlign};
	font-size: ${(props) => props.fontSize};
	width: ${(props) => props.width};
	z-index: ${(props) => props.zIndex};
	border-radius: ${(props) => props.borderRadius};
	overflow: ${(props) => props.overflow};
	border-top: ${(props) => props.borderTop};
	align-self: ${(props) => props.alignSelf};
	&:hover {
		background: ${(props) => props.hoverBackground};
	}
`;

const Seperator = styled.div`
	margin: 0 1rem;
	border-top: 1px solid rgba(0, 0, 0, 0.2);
`;

const AccountDrop = styled.div`
	border-radius: 10px;
	overflow-x: hidden;
	position: absolute;
	top: 4.8rem;
	right: 1rem;
	height: max-content;
	width: 18rem;
	background: #fff;
	z-index: ${zIndex.dropdown};
	box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const MiddleSection = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	overflow: hidden;
	min-width: 0;
	flex: 1;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		font-size: 0.9rem;
		flex: 1;
		justify-content: center;
	}
`;

const Span = styled.span`
	font-size: 2.5rem;
	user-select: none;
	&:hover {
		transform: scale(1.1);
		transition: 0.6s all ease-in-out;
	}
`;

const Overlay = styled.div`
	position: fixed;
	display: flex;
	justify-content: center;
	align-items: center;
	background: rgba(0, 0, 0, 0.3);
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	padding: 1rem;
	z-index: ${zIndex.modalBackdrop};
`;

const Modal = styled.div`
	display: flex;
	flex-direction: column;
	background: #ffffff;
	height: max-content;
	width: min(90vw, 30rem);
	overflow-x: hidden;
	border-radius: 10px;
	z-index: ${zIndex.modal};
	@media (max-width: ${BREAKPOINTS.desktop}px) {
		width: ${(props) => props.widthBefore1000 || "min(90vw, 30rem)"};
	}
`;

const Header = (props) => {
	const [dropdown, showDropdown] = useState(false);
	const [modal, showModal] = useState(false);
	const [width] = useWindowSize();
	const auth = getAuth();
	const user = auth.currentUser;
	const isMobile = width < BREAKPOINTS.tablet;

	return (
		<Head>
			<Div height="100%">
				<Item margin="0 0 0 0.5rem" alignItem="center">
					{isMobile && props.toggle ? (
						<img
							src={menu}
							alt="menu"
							style={{ height: "2.5rem", cursor: "pointer" }}
							onClick={() => props.toggle(!props.showSidebar)}
						/>
					) : (
						<NavLink to={"/"}>
							<img src={xook} alt="logo" style={{ height: "2.5rem" }} />{" "}
						</NavLink>
					)}
				</Item>
				<MiddleSection>
					{props.machinePage ? (
						<>
							<Item padding="0 0 0 0.5rem" flexDirection="column" jContent="center" alignItem="left">
						<NavLink to={"/"}>
							<SubItem fontFamily="sans-serif" fontSize="1.3rem" fontWeight="600" mobileFontSize="1rem">
								{props.location || props.machineID}
							</SubItem>
							<SubItem fontFamily="inherit" margin="0.2rem 0 0 0" fontWeight="300" mobileFontSize="0.75rem">
								{props.location ? props.machineID : ""}
							</SubItem>
						</NavLink>
							</Item>
							<NavLink to={"/"}>
								<Item fontSize="1.1rem" height="100%" alignItem="center" margin="0 0 0 0.5rem">
									<span className="material-symbols-outlined">expand_more</span>
								</Item>
							</NavLink>
						</>
					) : (
						<Div margin="0 0 0.8rem 0.5rem" display="inline-block" alignSelf="flex-end" jContent="flex-end" fontSize="1.3rem">
							{props.title}
						</Div>
					)}
				</MiddleSection>
			</Div>
			<Div>
				<Span className="material-symbols-outlined" onClick={() => showDropdown((initialState) => !initialState)}>
					person
				</Span>
			</Div>
			{dropdown ? <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: zIndex.dropdownBackdrop }} onClick={() => showDropdown(false)} /> : null}
			<CSSTransition in={dropdown} timeout={1000} classNames="page" unmountOnExit>
				<AccountDrop>
					<Div flexDirection="column" padding="1rem" jContent="center" alignItem="center">
						<Div jContent="center" alignItem="center" overflow="hidden" borderRadius="50%">
							<img style={{ height: "3.5rem" }} src={blankProfile} alt="profile" />
						</Div>
						<Div margin="1rem 0 0 0">{user.email}</Div>
					</Div>
					<Seperator />
					<Div onClick={() => showModal(true)} padding="1rem" hoverBackground="#faebd7">
						<span className="material-symbols-outlined">logout</span>
						&nbsp; Logout
					</Div>
				</AccountDrop>
			</CSSTransition>

			<CSSTransition in={modal} timeout={1000} classNames="container" unmountOnExit>
				<Overlay>
					<Modal>
						<Div alignItem="center" background="rgba(45, 35, 66, 0.8)" color="#fff" padding="1rem" jContent="space-between">
							<Div fontSize="1.4rem">Are you sure you want to Logout?</Div>
							<img
								style={{
									height: "1.5rem",
									filter: "invert(97%) sepia(0%) saturate(7500%) hue-rotate(126deg) brightness(111%) contrast(100%)",
								}}
								src={close}
								alt="close"
								onClick={() => {
									showModal(false);
								}}
							/>
						</Div>
						<Div padding="1rem" width="100%" jContent="flex-end">
							<Div
								width="max-content"
								margin="0.5rem"
								onClick={() => {
									showModal(false);
								}}>
								<Button>Cancel</Button>
							</Div>
							<Div width="max-content" margin="0.5rem">
								<SuccessButton
									onClick={() => {
										LogoutUser();
									}}>
									Confirm
								</SuccessButton>
							</Div>
						</Div>
					</Modal>
				</Overlay>
			</CSSTransition>
		</Head>
	);
};

export default LandingConnector(Header);
